import {CSSProperties, FC} from "react";
import {ControlSizeType, FormatValueType, LabelSizeType} from "../../../models";
import {formatValue} from "../../../utils";

export const LabelBox: FC<{
    labelName: string;
    inputValue:
        | string
        | ReadonlyArray<string>
        | number
        | boolean
        | undefined
        | null;
    controlSize?: ControlSizeType;
    labelSize?: LabelSizeType;
    id?: string | undefined;
    formatType?: FormatValueType;
    labelStyle?: CSSProperties;
    valueStyle?: CSSProperties;
}> = ({
          labelName,
          inputValue,
          controlSize = "col flex-form-control",
          labelSize = "form-label", id,formatType = "none",
         labelStyle,
         valueStyle,
      }) => {
    const uniqueId = id || `label_title_${Math.random()}`;
    return (
        <>
            <div className={controlSize} >
                <label id={`${uniqueId}_lt`} className={labelSize} style={labelStyle}>{labelName}</label>
                <label id={`${uniqueId}_lv`} className="form-control read-only" style={valueStyle}>{formatValue(inputValue,formatType)}</label>
            </div>
        </>
    );
};
